import { useTranslation } from '@ibe/components';
import { FormikErrors } from 'formik';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import Keys from '../../../../Translations/generated/FileUpload.en.json.keys';
import fallback from '../../../../Translations/generated/FileUpload.en.json';

const baseStyle = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  width: '100%',
  margin: '16px 0'
};

type FileUploadProps = {
  setFieldValue: (
    field: string,
    value: File,
    shouldValidate?: boolean | undefined
  ) => Promise<void | FormikErrors<{ csvFile: null; csvType: string }>>;
};

const FileUpload = ({ setFieldValue }: FileUploadProps) => {
  const { t } = useTranslation('FileUpload', fallback);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: { 'text/csv': ['.csv'] },
    maxFiles: 1,
    onDrop: file => {
      setFieldValue('file', file[0]);
    }
  });

  return (
    <div>
      <div {...getRootProps({ style: baseStyle })}>
        <input {...getInputProps()} />
        <p>{t(Keys.dropzoneText)}</p>
      </div>
      {acceptedFiles.length > 0 && <p>{t(Keys.selectedFileText) + ' ' + acceptedFiles[0].name}</p>}
    </div>
  );
};

export default FileUpload;
